<template>
  <v-app id="inspire">
    <!--<partner-navigation-menu v-model="drawer" />-->

    <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" color="primary" dark app fixed>
      <v-toolbar-title class="ml-0 pl-3">
        <!--<v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-xs-and-up"></v-toolbar-side-icon>-->
        <span></span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <span>{{userEmail}}</span>
      <v-toolbar-items>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn icon @click.stop="logout" v-on="on">
              <v-icon>exit_to_app</v-icon>
            </v-btn>
          </template>
          <span>Sair</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>

    <v-content>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              solo
              prepend-inner-icon="search"
              label="PESQUISE POR DOCUMENTO (SEM PONTOS, TRAÇOS NEM ESPAÇOS) OU POR NÚMERO DE ASSOCIADO (OS 5 DÍGITOS)"
              v-model="search"
              append-outer-icon
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-progress-linear :indeterminate="true" v-if="searching" height="3"></v-progress-linear>

            <template v-if="!searching">
              <v-alert
                :value="noResults"
                color="info"
                icon="info"
                outline
              >Nenhum resultado encontrado</v-alert>
              <v-list two-line subheader v-if="this.clientsById.length">
                <v-subheader inset>Resultados por número de associado</v-subheader>
                <v-list-tile
                  v-for="item in clientsById"
                  :key="item.id"
                  avatar
                  :class="!item.active?'red--text':''"
                >
                  <v-list-tile-avatar>
                    <v-icon large v-if="!item.active" color="red">warning</v-icon>
                    <v-icon large v-if="item.active" color="green">check_circle</v-icon>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ item.name }}
                      <template v-if="!item.active?'red--text':''">
                        -
                        <span class="red--text font-weight-black">INATIVO</span>
                      </template>
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      # {{ item.clientId }}
                      <span class="grey--text text--lighten-2">|</span>
                      {{ item.documentType }} {{ item.documentNumber }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-list two-line subheader v-if="this.clientsByDoc.length">
                <v-subheader inset>Resultados por documento</v-subheader>
                <v-list-tile v-for="item in clientsByDoc" :key="item.id" avatar color="red">
                  <v-list-tile-avatar>
                    <v-icon large v-if="!item.active" color="red">warning</v-icon>
                    <v-icon large v-if="item.active" color="green">check_circle</v-icon>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                    <v-list-tile-sub-title>
                      # {{ item.clientId }}
                      <span class="grey--text text--lighten-2">|</span>
                      {{ item.documentType }} {{ item.documentNumber }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </template>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import db from "@/services/database";
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  data: function() {
    return {
      drawer: true,
      search: "",
      clientsById: [],
      clientsByDoc: [],
      noResults: false,
      searching: false
    };
  },
  created: function() {
    this.debouncedSearch = this._.debounce(this.searchClients, 1000);
  },
  watch: {
    search: async function() {
      this.debouncedSearch();
    }
  },
  methods: {
    logout: function() {
      firebase.auth().signOut();
      this.$router.replace("login");
    },
    searchClients: async function() {
      this.clientsByDoc = [];
      this.clientsById = [];
      this.noResults = false;
      this.searching = true;

      try {
        let itemsById = [];
        let snapshot = await db
          .collection("clients")
          .where("clientId", "==", this.search)
          .orderBy("dependant")
          .get();

        if (snapshot.size > 0) {
          snapshot.forEach(doc => {
            itemsById.push(buildClient(doc));
          });
        }
        this.clientsById = itemsById;

        let itemsByDoc = [];
        snapshot = await db
          .collection("clients")
          .where("documentNumber", "==", this.search)
          .get();
        if (snapshot.size > 0) {
          snapshot.forEach(doc => {
            itemsByDoc.push(buildClient(doc));
          });
        }
        this.clientsByDoc = itemsByDoc;
        this.noResults =
          !!this.search &&
          this.clientsByDoc.length == 0 &&
          this.clientsById.length == 0;
      } catch (err) {
        alert(err);
      } finally {
        this.searching = false;
      }
    }
  },
  computed:{
    userEmail: function(){
      return firebase.auth().currentUser.email;
    }
  }
};

function buildClient(doc) {
  return {
    id: doc.id,
    clientId: doc.data().clientId || "0",
    name: doc.data().name,
    documentType: doc.data().documentType || "",
    documentNumber: doc.data().documentNumber || "",
    email: doc.data().email || "",
    dependant: doc.data().dependant || false,
    active: doc.data().active
  };
}
</script>


<style>
nav.v-toolbar {
  background-image: url(/logo-novo.png);
  background-size: 5rem;
  background-position: 1rem center;
}
</style>